module.exports = __webpack_public_path__ + "static/media/sec_cam_cropped.a03d76a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sec_cam_cropped.png
// module id = 43
// module chunks = 0